var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 11,
    viewBox: "0 0 7 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.31201 4.8035C0.11223 4.98824 0 5.23877 0 5.5C0 5.76123 0.11223 6.01176 0.31201 6.1965L5.20657 10.7213C5.40509 10.9011 5.67237 11.0013 5.95033 11C6.22828 10.9987 6.49445 10.896 6.691 10.7143C6.88754 10.5326 6.99858 10.2866 6.99999 10.0296C7.00139 9.77268 6.89305 9.52559 6.69849 9.34207L2.54243 5.5L6.69849 1.65793C6.89305 1.47441 7.00139 1.22732 6.99999 0.970369C6.99858 0.713414 6.88754 0.467353 6.691 0.285657C6.49445 0.10396 6.22828 0.00131024 5.95033 1.24561e-05C5.67237 -0.00128533 5.40509 0.0988741 5.20657 0.278726L0.31201 4.8035Z",
    fill: "#7E839A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/ArrowLeft.b3fc0998f1916e9c55bebde8eb17a09e.svg";
export { ForwardRef as ReactComponent };